import React, { useEffect, useState } from "react";
import { MdSunny } from "react-icons/md";
import { BsFillMoonStarsFill } from "react-icons/bs";

export default function ThemeToggle({
  className = "",
  floating = true,
  sizeClassName = "rounded-2xl p-3",
}) {
  const [mode, setMode] = useState(
    localStorage.getItem("themeMode") ? localStorage.getItem("themeMode") : ""
  );

  useEffect(() => {
    if (mode === "" && document.documentElement.classList.contains("dark")) {
      document.documentElement.classList.remove("dark");
    }
    if (
      mode === "dark" &&
      !document.documentElement.classList.contains("dark")
    ) {
      document.documentElement.classList.add("dark");
    }
  }, [mode]);

  const changeTheme = () => {
    document.documentElement.classList.toggle("dark");
    if (document.documentElement.classList.contains("dark")) {
      localStorage.setItem("themeMode", "dark");
      setMode("dark");
    } else {
      localStorage.setItem("themeMode", "");
      setMode("");
    }
  };

  return (
    <button
      type="button"
      className={`portal-theme-toggle ${floating ? "fixed bottom-4 z-50 ltr:right-4 rtl:left-4" : ""} ${sizeClassName} flex items-center justify-center ${className}`.trim()}
      onClick={changeTheme}
    >
      {mode === "dark" ? (
        <BsFillMoonStarsFill className="text-white" />
      ) : (
        <MdSunny className="text-white" />
      )}
      <span className="sr-only">change theme</span>
    </button>
  );
}
